// extracted by mini-css-extract-plugin
module.exports = {"menuRoot":"styles_menuRoot__u1x25","isShortenMenu":"styles_isShortenMenu__efvqo"};